import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FieldSelect, FlexBox, Switch, Text, } from '@dixa/lib-shared-habla';
import { colors, sizes } from '@dixa/lib-shared-tokens';
import { useCallback, useState } from 'react';
import { useUpdateEffect } from 'react-use';
import { flowsApi } from 'apis/flows';
export const HolidayCalendarSelector = ({ clearable, onChange, }) => {
    const [isClosed, setIsClosed] = useState(false);
    const [countryCode, setCountryCode] = useState(null);
    const { countries } = flowsApi.useReadFlowsSchedulesCountriesQuery(undefined, {
        selectFromResult: ({ data }) => {
            var _a, _b;
            const countries = [...((_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.countries) !== null && _b !== void 0 ? _b : [])];
            return {
                countries: countries.sort(({ name: aName }, { name: bName }) => aName.localeCompare(bName)),
            };
        },
    });
    useUpdateEffect(() => {
        onChange(countryCode, isClosed);
    }, [countryCode, isClosed]);
    const handleSwitchChange = useCallback(({ target: { checked: isClosed }, }) => {
        setIsClosed(isClosed);
    }, []);
    return (_jsxs(Box, { children: [_jsx(FieldSelect, Object.assign({ input: {
                    name: 'holiday-calendar',
                    value: countryCode !== null && countryCode !== void 0 ? countryCode : '',
                    onChange: (countryCode) => setCountryCode(countryCode !== null && countryCode !== void 0 ? countryCode : null),
                }, items: countries.map(({ country_code, name }) => ({
                    id: country_code,
                    name,
                })), label: "Holiday calendar", noAlert: true, placeholder: "Connect holiday calendar with this schedule" }, (clearable && {
                clearable: true,
                onClear: () => setCountryCode(null),
            }), { searchable: true })), !!countryCode && (_jsxs(FlexBox, Object.assign({ alignItems: "center", background: colors.neutral['100'], borderRadius: sizes['border-radius']['100'], justifyContent: "space-between", margin: "250 0 0", padding: "300" }, { children: [_jsx(Text.Paragraph, { children: "Set business hours to \"closed\" on holidays." }), _jsx(Switch, { name: "is-closed", value: "is-closed", checked: isClosed, onChange: handleSwitchChange })] })))] }));
};
